const ITEMS = ["Clean Cars", "Quality Service", "Professional Results", "We Come To You"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="font-display px-8 text-[clamp(1.6rem,3.4vw,2.75rem)] font-semibold uppercase tracking-wide text-white md:px-12">
          {item}
        </span>
        <span className="h-2.5 w-2.5 rotate-45 bg-[#E60000]" aria-hidden="true" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    data-testid="brand-marquee"
    aria-hidden="true"
    className="relative overflow-hidden border-y border-white/10 bg-[#0A0A0A] py-6"
  >
    <div className="animate-marquee flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);

export default Marquee;
